export default "__VITE_ASSET__281f503a__"